var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CompanyListTemplate'),_c('HeaderTemplate'),_vm._t("default"),_c('FooterTemplate')],2)}
var staticRenderFns = []

export { render, staticRenderFns }